export default {
    SocialLogin: {
        "Wellcome to": "Добро пожаловать в",
        "Unfortunately": "К сожалению",
        "this account has been banned": "этот аккаунт был забанен",
        "Back to login": "Назад к логину",
        "Continue with": "Продолжить с",
        "By creating account you accept terms of use": "Создавая аккаунт вы соглашаетесь с правилами использования",
    },
    RegistrationFirebase: {
        "Registration": "Регистрация",
        "Email": "Эл. почта",
        "Password": "Пароль",
        "Confirm password": "Подтверждение пароля",
        "CONTINUE": "ПРОДОЛЖИТЬ",
        "Already have an account?": "Уже есть аккаунт?",
    },
    MainSlot: {
        "Events": "События",
        "My Calendar": "Мой календарь",
        "Friends": "Друзья",
        "Invite a friend": "Invite a friend",
        "My profile": "My profile",
        "Edit profile": "Edit profile",
        "Deactivate account": "Deactivate account",
        "Log out": "Log out",
        "Who we are?": "Who we are?",
        "Terms and Conditions": "Terms and Conditions",
        "Quick Privacy Settings": "Quick Privacy Settings",
        "Help Center": "Help Center",
        "Are you sure you want to log out?": "Are you sure you want to log out?",
        "Event will start in": "Event will start in",
        "To event page": "To event page",
        "Meeting Error": "Meeting Error",
        "Reserve a seat": "Зарезервировать место",
        "Congratulations!": "Поздравляем!",
        "You have reserved a seat at a new event. <br> You can cancel your reservation at any time.": "Вы зарезервировали место на новый ивент. <br> Вы можете отменить резерв в любое время.",
        "You have reserved a seat at a new event.": "Вы зарезервировали место на новый ивент.",
        "You can cancel your reservation at any time.": "Вы можете отменить резерв в любое время.",
        "Cancel reservation": "Отменить резервацию",
        "Your reservation was successfully canceled.": "Ваш резерв успешно отменен.",
        "Are you sure you want to cancel your reservation for": "Вы уверены что хотите отменить вашу резервацию на",
        "on": "в", // [title] on [date]
    },
    Calendar: {
        "My calendar": "Мой календарь",
        "Future events": "Будущие события",
        "Past events": "Прошлые события",
        "You don’t have any future events yet.": "У вас нет будущих событий.",
        "You don’t have any past events yet.": "У вас пока нет прошлых событий",
        "users per conversation": "пользователей для взаимодействия",
        "Online event": "Онлайн событие",
        "Offline event": "Оффлайн событие",
        "friends": "друзьей",
        "No matches": "Нет совпадений",
    },
    buttons: {
        "OK": "ХОРОШО"
    },
    validation: {
        "Passwords do not match. Please, try again.": "Пароли не совпадают. Пожалуйста, попробуйте еще раз.",
        "Invalid Email Format.": "Неверный формат Эл. почты.",
        "Password length must be between 8 and 20 characters.": "Длинна пароля должна быть от 8 до 20 символов",
        "Validation error": "Ошибка валидации",
        "Something went wrong...": "Что-то пошло не так...",

    }
}
